import { useContext, useEffect, useState } from "react";
import Context from "../../context/AppContext";
import { NavLink as Link } from "react-router-dom";

const Menu = () => {
  const { user } = useContext(Context);

  const [menuOpen, setMenuOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  // Default DARK
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("travelTheme");

    // Agar pehle theme save nahi hai -> dark
    return savedTheme ? savedTheme === "dark" : true;
  });

  const handleToggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  /* =================================
     THEME
  ================================= */

  useEffect(() => {
    document.body.classList.toggle("light-theme", !darkMode);
    document.body.classList.toggle("dark-theme", darkMode);

    localStorage.setItem(
      "travelTheme",
      darkMode ? "dark" : "light"
    );
  }, [darkMode]);


  /* =================================
     SCROLL
  ================================= */

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <>
      <header className={`mainheader ${scrolled ? "scrolled" : ""}`}>

        <div className="container">

          <nav className="navbar navbar-expand-lg navbar-dark">

            <a
              className="navbar-brand"
              href="./"
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="300"
            ><img src="/images/logo.png" className="img-fluid dl" alt="Logo Dark"/>
            <img src="/images/logo-light.png" className="img-fluid dd" alt="Logo Light"/>
            </a>


            <button
              onClick={handleToggleMenu}
              className={`navbar-toggler collapsed ${
                menuOpen ? "show1" : ""
              }`}
              type="button"
              aria-label="Toggle navigation"
            >
              <i className="fa-solid fa-xmark"></i>
              <i className="fa-solid fa-bars"></i>
            </button>


            <div
              id="navbarScroll"
              className={`collapse navbar-collapse justify-content-end ${
                menuOpen ? "show1" : ""
              }`}
            >

              <div
                className="d-flex align-items-center"
                data-aos="fade"
                data-aos-delay="500"
                data-aos-duration="300"
              >

                <div className="d-flex align-items-center">

                  <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll align-items-md-center">

                    <li className="nav-item">
                      <a
                        onClick={handleCloseMenu}
                        className="nav-link"
                        href="./"
                      >
                        Home
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        onClick={handleCloseMenu}
                        className="nav-link"
                        target="_blank"
                        rel="noreferrer"
                        href="https://trustbitcoin.io/about"
                      >
                        Trust Bitcoin Blockchain
                      </a>
                    </li>

                    <li className="nav-item">
                      <a
                        onClick={handleCloseMenu}
                        className="nav-link"
                        target="_blank"
                        rel="noreferrer"
                        href="https://scan.trustbitcoin.io/"
                      >
                        Explorer
                      </a>
                    </li>


                  {/* =========================
                      DARK / LIGHT TOGGLE
                  ========================= */}

                  <li className="themeToggle">

                    <button
                      type="button"
                      className={`themeSwitch ${
                        darkMode ? "dark" : "light"
                      }`}
                      onClick={() => setDarkMode((prev) => !prev)}
                      aria-label={
                        darkMode
                          ? "Switch to light mode"
                          : "Switch to dark mode"
                      }
                    >

                      <span className="themeIcon themeSun">
                        <i className="fa-solid fa-sun"></i>
                      </span>

                      <span className="themeIcon themeMoon">
                        <i className="fa-solid fa-moon"></i>
                      </span>

                    </button>

                  </li>
                    <li className="nav-item">

                      {!user && (
                        <Link
                          onClick={handleCloseMenu}
                          className="loginBTN"
                          to="/login"
                        >
                          <span>
                            <i className="userICON fa-solid fa-user"></i>
                          </span>
                          Login
                        </Link>
                      )}

                      {user && (
                        <Link
                          onClick={handleCloseMenu}
                          className="loginBTN"
                          to="/dashboard"
                        >
                          <span>
                            <i className="userICON fa-solid fa-house"></i>
                          </span>
                          Dashboard
                        </Link>
                      )}

                    </li>

                  </ul>


                </div>

              </div>

            </div>

          </nav>

        </div>

      </header>
    </>
  );
};

export default Menu;